module.exports = __webpack_public_path__ + "static/img/dizuo.1408dbd1.png";